import React from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { createOutsideTransaction, updateTransactionDetails } from "../../../redux/actions/FundsActions";
import { addTag, updateTag } from "../../../redux/actions/SettingsActions";

import Modal from "../../commonComponents/util/Modal";
import NavigationComponent from "../../commonComponents/util/NavigationComponent";
import TransactionTypeModal from "./TransactionTypeModal";
import Select from "../../commonComponents/util/Select";
import ValidatedInput from "../../commonComponents/util/ValidatedInput";
import CurrencyFormatInput from "../../commonComponents/util/CurrencyFormatInput";
import RadioGroup from "../../commonComponents/util/RadioGroup";
import FadeOutErrorMessage from "../../commonComponents/util/FadeOutErrorMessage";
import LoadingSpinner from "../../commonComponents/util/LoadingSpinner";

import { TagNames, TransactionTypes } from "../../../lib/constants";
import { formatDateForInput } from "../../../lib/utils";

const initialState = {
  error: false,
  transaction: {
    transactionType: TransactionTypes.Deposit,
    amount: "",
    description: "",
    date: "",
    withdrawalTypeId: null,
    depositSourceId: null,
    outsideTransactionOtherSource: ""
  },
  transactionTypeForUpdate: null,
  submitAttempted: false,
  useTransactionOtherSource: false
};

class OutsideTransactionModal extends NavigationComponent {
  constructor(props) {
    super(props);

    this.state = {
      showModals: {
        transactionTypeModal: false
      },
      ...initialState
    };
  }

  componentWillUpdate(nextProps) {
    if(nextProps.show && !this.props.show && nextProps.transactionForUpdate) {
      const {
        transactionForUpdate: {
          amount, date, depositSourceId, description, 
          outsideTransactionOtherSource, transactionId, type, withdrawalTypeId
        }
      } = nextProps;

      this.setState({
        transaction: {
          transactionId: transactionId,
          transactionType: type || "",
          amount: amount || "",
          description: description || "",
          date: formatDateForInput(date) || "",
          withdrawalTypeId: withdrawalTypeId || null,
          depositSourceId: depositSourceId || null,
          outsideTransactionOtherSource: outsideTransactionOtherSource || ""
        },
        useTransactionOtherSource: !!outsideTransactionOtherSource
      });
    }
  }

  save = async () => {
    this.setState({ submitAttempted: true, error: false });

    const { transaction } = this.state;
    if (
      !transaction.amount ||
      !transaction.description ||
      !transaction.date ||
      (!transaction.withdrawalTypeId && !transaction.depositSourceId && !transaction.outsideTransactionOtherSource)
    )
      return;

    if(this.props.transactionForUpdate) {
      const { transactionId, withdrawalTypeId, ...transFields } = transaction;
      await this.props.actions.updateTransactionDetails(
        this.props.fundId,
        transactionId,
        {
          ...transFields,
          withdrawalSourceId: withdrawalTypeId //Note - rename withdrawalTypeId to withdrawalSourceId for patch doc naming purposes
        }
      );
    } else {
      await this.props.actions.createOutsideTransaction(
        this.props.fundId,
        transaction
      );
    }

    if (!this.props.success) {
      this.setState({ error: true });
    } else {
      if (this.props.onSuccess)
        this.props.onSuccess(transaction.transactionType);
      this.close();
    }
  };

  saveTransactionType = async value => {
    const tagName =
      this.state.transaction.transactionType === TransactionTypes.Deposit
        ? TagNames.DepositSources
        : TagNames.WithdrawalTypes;

    const isUpdate = this.state.transactionTypeForUpdate;
    if (isUpdate) {
      await this.props.actions.updateTag(tagName, value);
    } else {
      await this.props.actions.addTag(tagName, value);
    }

    if (
      this.props.systemSettings[tagName][isUpdate ? "update" : "add"].success
    ) {
      if (isUpdate) {
        this.props.onUpdateTransactionType();
      } else {
        if (tagName === TagNames.DepositSources) {
          this.setState({
            transaction: {
              ...this.state.transaction,
              depositSourceId: this.props.systemSettings[
                TagNames.DepositSources
              ].add.data
                ? this.props.systemSettings[TagNames.DepositSources].add.data
                    .key
                : null
            }
          });
        } else {
          this.setState({
            transaction: {
              ...this.state.transaction,
              withdrawalTypeId: this.props.systemSettings[
                TagNames.WithdrawalTypes
              ].add.data
                ? this.props.systemSettings[TagNames.WithdrawalTypes].add.data
                    .key
                : null
            }
          });
        }
      }
    }
  };

  close = () => {
    this.setState(initialState, this.props.close);
  };

  onChange = (name, value) => {
    this.setState({
      transaction: { ...this.state.transaction, [name]: value }
    });
  };

  onChangeTransactionSourceId = (name, value) => {
    const useTransactionOtherSource = value === "useTransactionOtherSource";
    this.setState({
      transaction: { 
        ...this.state.transaction, 
        [name]: useTransactionOtherSource ? null : value,
        outsideTransactionOtherSource: ""
       },
       useTransactionOtherSource
    });
  }

  updateTransactionType = (name, value) => {
    this.setState({
      transaction: {
        ...this.state.transaction,
        [name]: value,
        withdrawalTypeId: null,
        depositSourceId: null,
        outsideTransactionOtherSource: ""
      },
      useTransactionOtherSource: false
    });
  };

  render() {
    const { transaction, submitAttempted, useTransactionOtherSource } = this.state;

    const { transactionForUpdate } = this.props;
    const transactionIsReconciled = !!(transactionForUpdate && transactionForUpdate.reconciliationId);

    const descriptionItems = [
      "deposit by avi schron",
      "deposit for shmaya",
      "deposit from ofman",
      "dividends paid from bank",
      "donation income chaya cohen",
      "donation income rubin schron",
      "federal tax on dividends withheld",
      "payroll",
      "transfer from RS charity acct",
      "wire to BMA Special- Israel",
      "wire transfer",
    ];

    return (
      <Modal modalShowing={this.props.show}>
        <div className="modal-container">
          <div className="modal new-transaction-modal large-modal">
            <div className="modal-header">
              <h4 className="page-header">{transaction.transactionId ? "Edit" : "New"} Outside Transaction</h4>
              <i className="icon ion-ios-close-empty" onClick={this.close} />
            </div>
            <div className="modal-section">
              <RadioGroup
                name="transactionType"
                title="Transaction Type"
                value={transaction.transactionType}
                options={[
                  {
                    key: TransactionTypes.Deposit,
                    value: TransactionTypes.Deposit
                  },
                  {
                    key: TransactionTypes.Withdrawal,
                    value: TransactionTypes.Withdrawal
                  }
                ]}
                onChange={this.updateTransactionType}
              />
            </div>
            <div className="modal-section">
              <div className="modal-row">
                <div className="column-half">
                  <ValidatedInput
                    input={
                      <CurrencyFormatInput 
                        disabled={transactionIsReconciled} 
                        isIsraeli={this.props.isIsraeli} 
                      />
                    }
                    name="amount"
                    value={transaction.amount}
                    onChange={this.onChange}
                    required={true}
                    showRequiredError={submitAttempted}
                    label={`Amount ${transactionIsReconciled ? "*" : ""}`}
                  />
                </div>
                <div className="column-half">
                  <ValidatedInput
                    input={<span><input type="text" list="description" name="description" />
                      <datalist id="description">
                        {descriptionItems.map((item, key) =>
                          <option key={key} value={item} />
                        )}
                      </datalist>
                    </span>}
                    label="Description"
                    name="description"
                    value={transaction.description}
                    onChange={this.onChange}
                    required={true}
                    showRequiredError={submitAttempted}
                  />
                </div>
              </div>
            </div>
            <div className="modal-section">
              <div className="modal-row">
                <div className="column-half">
                  <ValidatedInput
                    input={
                      <input 
                        disabled={transactionIsReconciled} 
                        type="date" 
                      />
                    }
                    value={transaction.date}
                    name="date"
                    label={`Date ${transactionIsReconciled ? "*" : ""}`}
                    onChange={this.onChange}
                    required={true}
                    showRequiredError={submitAttempted}
                  />
                </div>
                <div className="column-half">
                  <span
                    className="link-text xs-text right lowercase-text"
                    onClick={this.toggleModal.bind(
                      this,
                      "transactionTypeModal"
                    )}
                  >
                    Add New
                  </span>
                  {!!(
                    transaction.depositSourceId || transaction.withdrawalTypeId
                  ) && (
                    <i
                      className="icon-pencil link-text right mr-8"
                      onClick={() =>
                        this.setState(
                          {
                            transactionTypeForUpdate: transaction.depositSourceId
                              ? this.props.utils.depositSources.find(
                                  source =>
                                    source.key.toString() ===
                                    transaction.depositSourceId.toString()
                                )
                              : transaction.withdrawalTypeId
                              ? this.props.utils.withdrawalTypes.find(
                                  source =>
                                    source.key.toString() ===
                                    transaction.withdrawalTypeId.toString()
                                )
                              : null
                          },
                          this.toggleModal.bind(this, "transactionTypeModal")
                        )
                      }
                      style={{ borderBottom: "none" }}
                    />
                  )}
                  {transaction.transactionType === TransactionTypes.Deposit ? (
                    <ValidatedInput
                      input={
                        <Select options={[
                          ...this.props.utils.depositSources,
                          { key: "useTransactionOtherSource", value: "Other"}
                        ]} />
                      }
                      label="Deposit Source"
                      name="depositSourceId"
                      value={useTransactionOtherSource ? "useTransactionOtherSource" : transaction.depositSourceId}
                      onChange={this.onChangeTransactionSourceId}
                      required={true}
                      showRequiredError={submitAttempted}
                    />
                  ) : (
                    <ValidatedInput
                      input={
                        <Select options={[
                          ...this.props.utils.withdrawalTypes,
                          { key: "useTransactionOtherSource", value: "Other"}
                        ]} />
                      }
                      label="Withdrawal Type"
                      name="withdrawalTypeId"
                      value={useTransactionOtherSource ? "useTransactionOtherSource" : transaction.withdrawalTypeId}
                      onChange={this.onChangeTransactionSourceId}
                      required={true}
                      showRequiredError={submitAttempted}
                    />
                  )}
                </div>
              </div>
            </div>
            {(useTransactionOtherSource) && (
              <div className="modal-section">
                <div className="modal-row">
                  <div className="column-half">
                    <ValidatedInput
                      input={
                        <input type="text" />
                      }
                      label={`Other ${transaction.transactionType === TransactionTypes.Deposit ? "Deposit Source" : "Withdrawal Type"}`}
                      name="outsideTransactionOtherSource"
                      value={transaction.outsideTransactionOtherSource}
                      onChange={this.onChange}
                      required={true}
                      showRequiredError={submitAttempted}
                    />
                  </div>
                  <div className="column-half" />
                </div>
              </div>
            )}
            {transactionIsReconciled && (
              <span className="accent-text xs-text">
                *This transaction is already marked as cleared. Please unclear it in order to edit the amount or date fields.
              </span>
            )}
            {this.props.loading ? (
              <LoadingSpinner height={20} alignRight={true} />
            ) : (
              <div className="modal-btns text-right">
                <button className="btn btn-accent" onClick={this.close}>
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={this.save}>
                  Save
                </button>
                <FadeOutErrorMessage show={this.state.error} timeOut={5000} />
              </div>
            )}
          </div>
        </div>

        <TransactionTypeModal
          close={() => {
            this.toggleModal("transactionTypeModal");
            if (this.state.transactionTypeForUpdate) {
              this.setState({ transactionTypeForUpdate: null });
            }
          }}
          save={this.saveTransactionType}
          show={this.state.showModals.transactionTypeModal}
          title={
            transaction.transactionType === TransactionTypes.Deposit
              ? "Deposit Source"
              : "Withdrawal Type"
          }
          transactionType={this.state.transactionTypeForUpdate}
          success={
            this.props.systemSettings[
              transaction.transactionType === TransactionTypes.Deposit
                ? TagNames.DepositSources
                : TagNames.WithdrawalTypes
            ][this.state.transactionTypeForUpdate ? "update" : "add"].success
          }
          loading={
            this.props.systemSettings[
              transaction.transactionType === TransactionTypes.Deposit
                ? TagNames.DepositSources
                : TagNames.WithdrawalTypes
            ][this.state.transactionTypeForUpdate ? "update" : "add"].loading
          }
          data={
            this.props.systemSettings[
              transaction.transactionType === TransactionTypes.Deposit
                ? TagNames.DepositSources
                : TagNames.WithdrawalTypes
            ][this.state.transactionTypeForUpdate ? "update" : "add"].data
          }
        />
      </Modal>
    );
  }
}

function mapStateToProps(state, thisProps) {
  return {
    ...state.fundDetails[thisProps.transactionForUpdate ? "updateTransaction" : "newOutsideTransaction"],
    utils: {
      depositSources:
        state.settings.systemSettings.data.fundSettings.depositSources,
      withdrawalTypes:
        state.settings.systemSettings.data.fundSettings.withdrawalTypes
    },
    systemSettings: state.systemSettings
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        createOutsideTransaction,
        updateTransactionDetails,
        addTag,
        updateTag
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OutsideTransactionModal);



// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundsCommon/OutsideTransactionModal.jsx